import React, { useEffect, useState } from "react";
import Input from "../Elements/Input/Input";
import Button from "../Elements/Button/Button";
import Loading from "../../Loader/Loader";
import cp from "../../../img/cloudpayments.svg";
import tinkoffLogo from "../../../img/payIcons/icon-cards-ru.png";
import tinkoffCreditLogo from "../../../img/payIcons/tinkoff.svg";
import tDolyami from "../../../img/payIcons/t-dolyami.jpg";
import pp from "../../../img/payIcons/icon-cards-world.png";
import sbp from "../../../img/payIcons/sbp.png";
import sberpayLogo from "../../../img/payIcons/icon-sbol.png";
import sberLoanLogo from "../../../img/payIcons/icon-sbrf.png";
import byPayIcon from "../../../img/payIcons/icon-card-by.png";
import { PROXY_URL, CP_PUBLIK_KEY_RU, CP_PUBLIK_KEY_SNG } from "../../../shared/constants";
import { useUserContext } from "../../../context/UserContext";
import { fromRubToKZT } from "../../../shared/utils";
import Promocode from "../../Promocode/Promocode";
import "./Buy.css";

export default Buy = ({
	usePromocode,
}) => {
	const [email, setEmail] = useState('');
	const [isWaitingAnswer, setIsWaitingAnswer] = useState(false);
	const [errors, setErrors] = useState({
		email: '',
	});
	const [existsError, setExistsError] = useState(false);
	const [answerText, setAnswerText] = useState('');
	const { be } = errors;
	const { basketData, setOrder, userProfile, orderData } = useUserContext();
	const [isDisabled, setIsDisabled] = useState(true);
	const [isAgree, setIsAgree] = useState(false);
	const [isSelectedPS, setIsSelectedPS] = useState(false);
	const [isRus, setisRus] = useState(true);

	const setAgree = (e) => {
		setIsAgree(e.target.checked);
	};

	const [defaultPaySystem, setDefaultPaySystem] = useState(true);
	useEffect(() => {
		const randomDefaultCheckedPaysystem = () => {
			return "cp-ru";
		}

		const checkedPaysystem = randomDefaultCheckedPaysystem();
		setDefaultPaySystem(checkedPaysystem);
	}, []);

	const selectPS = (e) => {
		if (e.target.value === 'cp-ru') {
			setisRus(true);
		} else {
			setisRus(false);
		}
		setIsSelectedPS(true);

		let paysystem = '';
		setDefaultPaySystem(e.target.value);
		switch (e.target.value) {
			case 'tinkoff':
			default:
				paysystem = 'TINKOFF';
				break;

			case 'tinkoff_credit':
				paysystem = 'TINKOFF_INSTALLMENT_3';
				break;

			case 'tinkoff_sbp':
				paysystem = 'TINKOFF_SBP';
				break;

			case 'tinkoff_dolyami':
				paysystem = 'TINKOFF_DOLYAMI';
				break;

			case 'cp-sng':
				paysystem = 'CLOUDPAYMENTS_KZ';
				break;

			case 'pp':
				paysystem = 'PAYINPAYOUT';
				break;

			case 'prodamus':
				paysystem = 'PRODAMUS';
				break;

			case 'prodamus_BY':
				paysystem = 'PRODAMUS_BY';
				break;

			case 'prodamus_SELECT':
				paysystem = 'PRODAMUS_SELECT';
				break;

			case 'ps-ru':
				paysystem = 'PAYSELECTION';
				break;

			case 'sberpay':
				paysystem = 'SBERPAY';
				break;

			case 'sber_loan':
				paysystem = 'SBER_LOAN';
				break;

			case 'cp-ru':
		}
		setOrder({
			...orderData,
			paysystem: paysystem
		});
	};

	useEffect(() => {
		if (setIsDisabled && isAgree && isSelectedPS) {
			setIsDisabled(false);
			// prepare order data
			const cur = (isRus) ? 'RUB' : 'KZT';
			const keyCP = (isRus) ? CP_PUBLIK_KEY_RU : CP_PUBLIK_KEY_SNG;
			const pr = (isRus) ? Number(basketData['price_clear']) : Number(fromRubToKZT(basketData['price_clear']));
			setOrder({
				...orderData,
				accountId: userProfile['login'],
				amount: pr,
				currency: cur,
				publicId: keyCP,
			});
		} else {
			setIsDisabled(true);
		}
	}, [
		isAgree,
		isSelectedPS,
	]);
	return (
		<div className="buyWrapper">
			{
				isWaitingAnswer &&
				<div className="loaderWrapper">
					<Loading width={100} />
				</div>
			}
			{
				!isWaitingAnswer &&
				<>
					<h2 className="buyFormTitle">Выберите способ оплаты</h2>
					<div className="cpWrapperMain">
						<div className="cpWrapper1">
							<input
								checked={defaultPaySystem === 'tinkoff_sbp'}
								onChange={selectPS}
								type="radio"
								id="tinkoff_sbp"
								name="payment"
								value="tinkoff_sbp"
								className="cpRadio"
							/>
							<label htmlFor="tinkoff_sbp" className="cpLabel">
								<img src={sbp} className="cpImage" />
								Быстрый платеж без ввода данных карты. Для карт РФ (СБП)
							</label>
						</div>
						<div className="cpWrapper1">
							<input
								checked={defaultPaySystem === 'tinkoff'}
								onChange={selectPS}
								type="radio"
								id="tinkoff"
								name="payment"
								value="tinkoff"
								className="cpRadio"
							/>
							<label htmlFor="tinkoff" className="cpLabel">
								<img src={tinkoffLogo} className="cpImage" />
								Оплата картой, выпущенной в РФ и СНГ (карта МИР)
							</label>
						</div>
						{/*<div className="cpWrapper1">*/}
						{/*	<input*/}
						{/*		checked={defaultPaySystem === 'pp'}*/}
						{/*		onChange={selectPS}*/}
						{/*		type="radio"*/}
						{/*		id="pp"*/}
						{/*		name="payment"*/}
						{/*		value="pp"*/}
						{/*		className="cpRadio"*/}
						{/*	/>*/}
						{/*	<label htmlFor="pp" className="cpLabel">*/}
						{/*		<img src={pp} className="cpImage" />*/}
						{/*		Оплата картой всех стран мира, включая СНГ*/}
						{/*	</label>*/}
						{/*</div>*/}
						<div className="cpWrapper1">
							<input
								checked={defaultPaySystem === 'prodamus'}
								onChange={selectPS}
								type="radio"
								id="prodamus"
								name="payment"
								value="prodamus"
								className="cpRadio"
							/>
							<label htmlFor="prodamus" className="cpLabel">
								<img src={pp} className="cpImage" />
								Оплата картой всех стран мира, включая СНГ
							</label>
						</div>
						<div className="cpWrapper1">
							<input
								checked={defaultPaySystem === 'prodamus_BY'}
								onChange={selectPS}
								type="radio"
								id="prodamus_BY"
								name="payment"
								value="prodamus_BY"
								className="cpRadio"
							/>
							<label htmlFor="prodamus_BY" className="cpLabel">
								<img src={byPayIcon} className="cpImage" />
								Оплата картой Беларусь
							</label>
						</div>
						<div className="cpWrapper1">
							<input
								checked={defaultPaySystem === 'sberpay'}
								onChange={selectPS}
								type="radio"
								id="sberpay"
								name="payment"
								value="sberpay"
								className="cpRadio"
							/>
							<label htmlFor="sberpay" className="cpLabel">
								<img src={sberpayLogo} className="cpImage" />
								SberPay
							</label>
						</div>
						{basketData.price_clear >= 1000 && basketData.price_clear <= 280000 && (
							<div className="cpWrapper">
								<input
									checked={defaultPaySystem === 'tinkoff_dolyami'}
									onChange={selectPS}
									type="radio"
									id="tinkoff_dolyami"
									name="payment"
									value="tinkoff_dolyami"
									className="cpRadio"
								/>
								<label htmlFor="tinkoff_dolyami" className="cpLabel">
									<img src={tDolyami} className="cpImage cpImage-tinkoff" />
									Оплата Долями
								</label>
							</div>
						)}
						{basketData.price_clear >= 3125 && basketData.price_clear <= 520833 && (
							<div className="cpWrapper">
								<input
									checked={defaultPaySystem === 'tinkoff_credit'}
									onChange={selectPS}
									type="radio"
									id="tinkoff_credit"
									name="payment"
									value="tinkoff_credit"
									className="cpRadio"
								/>
								<label htmlFor="tinkoff_credit" className="cpLabel">
									<img src={tinkoffCreditLogo} className="cpImage cpImage-tinkoff" />
									Рассрочка Тинькофф 3 месяца
								</label>
							</div>
						)}
						{basketData.price_clear >= 3000 && basketData.price_clear <= 700000 && (
							<div className="cpWrapper">
								<input
									checked={defaultPaySystem === 'sber_loan'}
									onChange={selectPS}
									type="radio"
									id="sber_loan"
									name="payment"
									value="sber_loan"
									className="cpRadio"
								/>
								<label htmlFor="sber_loan" className="cpLabel">
									<img src={sberLoanLogo} className="cpImage cpImage-tinkoff" />
									Рассрочка от Сбербанка на 6 месяцев
								</label>
							</div>
						)}
						<div className="cpWrapper1">
							<input
								checked={defaultPaySystem === 'prodamus_SELECT'}
								onChange={selectPS}
								type="radio"
								id="prodamus_SELECT"
								name="payment"
								value="prodamus_SELECT"
								className="cpRadio"
							/>
							<label htmlFor="prodamus_SELECT" className="cpLabel">
								<img src={pp} className="cpImage" />
								Оплата картой всех стран мира (резервный способ)
							</label>
						</div>
					</div>
					{usePromocode && <Promocode tariff={basketData.name} />}
					{!usePromocode && (
						<div className="cpWrapper2">
							<span className="cpPrice">К оплате {basketData.price}</span>
							<span className="cpTarriff"> Тариф {basketData.name}</span>
						</div>
					)}
					{(typeof defaultPaySystem === 'string' && defaultPaySystem.includes('prodamus')) && (
						<div className="cpWrapper2">
							<span className="warning">При оплате не из РФ взимается комиссия. Точная сумма будет указана перед подтверждением платежа.</span>
						</div>
					)}
					<div className="cpWrapper3">
						<div className="cpAgreeWrapper">

							<input type="checkbox" id="agree" onChange={setAgree} />
							<label htmlFor="agree" className="cpAgree">Ознакомлен/на с{' '}
								<a
									href="https://melannett.ru/upload/pdf/politika-bezopasnosti-personalnykh-dannyh.pdf"
									target="_blank"
								>
									политикой обработки персональных данных
								</a>
								{' '}и публичной{' '}
								<a href="https://melannett.ru/upload/public_offer_rf.pdf" target="_blank">офертой</a>.
							</label>
						</div>
						<div className="cpAgreeWrapper">
							<input type="checkbox" />
							<label htmlFor="agree" className="cpAgree">Согласен/на на получение информационной и{' '}
								<a
									href={PROXY_URL + '/upload/agreement_to_marketing_mailings.pdf'}
									target="_blank"
								>
									рекламной рассылки.
								</a>
							</label>
						</div>
					</div>
					<Button
						type="button"
						value="Оплатить"
						fields={{}}
						setIsWaitingAnswer={setIsWaitingAnswer}
						method="finish"
						validate={setErrors}
						existsErrors={setExistsError}
						setAnswerText={setAnswerText}
						disabled={isDisabled}
					/>
				</>
			}
		</div>
	);
}
